import React, { useState } from "react";
import ReactDOM from "react-dom";
import { useAuth } from "../../src/Context/AuthContext";
import { useNavigate } from 'react-router-dom';

const CreateAdminModal = ({ isOpen, onClose, onAdminCreated }) => {
    if (!isOpen) return null;

    // -------------------------
    // STATE
    // -------------------------
    const [form, setForm] = useState({
        firstName: "",
        lastName: "",
        userName: "",
        email: "",
        password: "",
        confirmPassword: "",
        underWritingPerm: false,
        imagePerm: false
    });

    const [loading, setLoading] = useState(false);
    const { logout } = useAuth();
    const navigate = useNavigate();

    const apiURL = import.meta.env.VITE_API;

    // -------------------------
    // HANDLERS
    // -------------------------
    const handleChange = (e) => {
        const { name, type, value, checked } = e.target;
        setForm({
            ...form,
            [name]: type === "checkbox" ? checked : value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        debugger;
        if (form.password !== form.confirmPassword) {
            alert("Passwords do not match!");
            return;
        }

        const { confirmPassword, ...payload } = form;

        try {
            setLoading(true);
            const res = await fetch(`${apiURL}/admin/create-admin`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
                credentials: "include"
            });

            const data = await res.json();

            if (res.status === 401) {
                logout();
                navigate('/login');
                return;
            }

            if (res.status === 403) {
                navigate('/home');
                return;
            }

            if (!res.ok) {
                throw new Error(data.message || "Failed to create admin");
            }

            onAdminCreated();
            onClose();
        } catch (err) {
            console.error(err);
            alert(err);
        } finally {
            setLoading(false);
        }
    };

    // -------------------------
    // RENDER
    // -------------------------
    return ReactDOM.createPortal(
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>Create New Admin</h3>
                    <button className="close-button" onClick={onClose}>✕</button>
                </div>

                <div className="modal-body">
                    <form onSubmit={handleSubmit}>

                        {/* TEXT FIELDS */}
                        {[
                            ["First Name", "firstName", "text"],
                            ["Last Name", "lastName", "text"],
                            ["Username", "userName", "text"],
                            ["Email", "email", "email"],
                        ].map(([label, name, type]) => (
                            <div className="form-group" key={name}>
                                <label>{label}</label>
                                <input
                                    type={type}
                                    name={name}
                                    className="filterInput"
                                    value={form[name]}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        ))}

                        <div className="form-group">
                            <label>Password</label>
                            <input
                                type="password"
                                name="password"
                                className="filterInput"
                                value={form.password}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>Confirm Password</label>
                            <input
                                type="password"
                                name="confirmPassword"
                                className="filterInput"
                                value={form.confirmPassword}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        {/* TOGGLES */}
                        <div className="form-group toggle-group">
                            <label>
                                <input
                                    type="checkbox"
                                    name="underWritingPerm"
                                    checked={form.underWritingPerm}
                                    onChange={handleChange}
                                />
                                Underwriting Permission
                            </label>
                        </div>

                        <div className="form-group toggle-group">
                            <label>
                                <input
                                    type="checkbox"
                                    name="imagePerm"
                                    checked={form.imagePerm}
                                    onChange={handleChange}
                                />
                                Image Permission
                            </label>
                        </div>

                        {/* ACTIONS */}
                        <div className="form-actions">
                            <button
                                type="submit"
                                className="baseButton"
                                disabled={loading}
                            >
                                {loading ? "Creating..." : "Create Admin"}
                            </button>
                            <button
                                type="button"
                                className="baseButton secondary"
                                onClick={onClose}
                            >
                                Cancel
                            </button>
                        </div>

                    </form>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default CreateAdminModal;
